(() => {
  const root = window.PrestTheme?.root || '/';
  const moneyFormat = window.PrestTheme?.moneyFormat || '${{amount}}';
  const body = document.body;

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const formatMoney = (cents) => {
    const number = Number(cents || 0) / 100;
    const amount = number.toFixed(2);
    const noDecimals = number.toFixed(0);
    return moneyFormat
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount}}', amount)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals);
  };

  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerItems = document.querySelector('[data-cart-items]');
  const drawerFooter = document.querySelector('[data-cart-footer]');
  const drawerTotal = document.querySelector('[data-cart-total]');

  const openCart = () => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add('cart-open');
    drawer.querySelector('[data-cart-close]')?.focus();
  };

  const closeCart = () => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    body.classList.remove('cart-open');
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = count;
    });
  };

  const renderCart = (cart) => {
    updateCartCount(cart.item_count);
    if (!drawerItems || !drawerFooter) return;

    if (!cart.items.length) {
      drawerItems.innerHTML = '<div class="empty-cart"><p>your cart is empty.</p><a class="btn secondary" href="/collections/all">view collection</a></div>';
      drawerFooter.hidden = true;
      return;
    }

    drawerItems.innerHTML = cart.items.map((item) => {
      const image = item.image
        ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}" loading="lazy">`
        : '';
      const options = item.options_with_values
        .map((option) => `${escapeHtml(option.value.toLowerCase())}`)
        .join(' / ');

      return `
        <article class="cart-item" data-line-key="${escapeHtml(item.key)}">
          <a class="cart-thumb" href="${escapeHtml(item.url)}">${image}</a>
          <div>
            <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title.toLowerCase())}</a></h3>
            <p>${options} / ${formatMoney(item.final_price)}</p>
            <div class="qty" aria-label="quantity">
              <button type="button" data-cart-quantity="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-quantity="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="increase quantity">+</button>
            </div>
          </div>
          <button class="remove-btn" type="button" data-cart-quantity="${escapeHtml(item.key)}" data-quantity="0" aria-label="remove item">×</button>
        </article>`;
    }).join('');

    drawerTotal.textContent = formatMoney(cart.total_price);
    drawerFooter.hidden = false;
  };

  const fetchCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('unable to load cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const changeCart = async (key, quantity) => {
    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Number(quantity) })
    });
    if (!response.ok) throw new Error('unable to update cart');
    renderCart(await response.json());
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-open]')) {
      fetchCart().then(openCart).catch(console.error);
    }
    if (event.target.closest('[data-cart-close]')) closeCart();

    const quantityButton = event.target.closest('[data-cart-quantity]');
    if (quantityButton) {
      quantityButton.disabled = true;
      changeCart(quantityButton.dataset.cartQuantity, quantityButton.dataset.quantity)
        .catch(console.error)
        .finally(() => { quantityButton.disabled = false; });
    }

    const menuButton = event.target.closest('[data-menu-toggle]');
    if (menuButton) {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const isOpen = menu.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
      body.classList.toggle('menu-open', isOpen);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeCart();
    document.querySelector('[data-mobile-menu]')?.classList.remove('open');
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    body.classList.remove('menu-open');
  });

  document.querySelectorAll('.js-product-form').forEach((form) => {
    const variants = JSON.parse(form.querySelector('[data-product-json]')?.textContent || '[]');
    const idInput = form.querySelector('[data-variant-id]');
    const price = form.closest('[data-product-section]')?.querySelector('[data-product-price]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const message = form.querySelector('[data-form-message]');

    const updateVariant = () => {
      const selectedOptions = [...form.querySelectorAll('[data-option-position]')]
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .map((fieldset) => fieldset.querySelector('[data-option-input]:checked')?.value);

      const variant = variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));
      if (!variant) {
        idInput.value = '';
        addButton.disabled = true;
        addButton.textContent = 'choose options';
        return;
      }

      idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'add to cart' : 'sold out';
      if (message) message.textContent = '';

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    form.addEventListener('change', updateVariant);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!idInput.value || addButton.disabled) return;
      addButton.disabled = true;
      addButton.textContent = 'adding...';
      if (message) message.textContent = '';

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'unable to add item');
        }
        await fetchCart();
        openCart();
      } catch (error) {
        if (message) message.textContent = error.message;
      } finally {
        updateVariant();
      }
    });

    updateVariant();
  });

  const filter = document.querySelector('[data-product-filter]');
  if (filter) {
    filter.addEventListener('input', () => {
      const query = filter.value.trim().toLowerCase();
      document.querySelectorAll('[data-product-card]').forEach((card) => {
        card.hidden = Boolean(query) && !card.dataset.title.includes(query);
      });
    });
  }

  const revealElements = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealElements.forEach((element) => revealObserver.observe(element));
  } else {
    revealElements.forEach((element) => element.classList.add('visible'));
  }

  const progress = document.querySelector('[data-scroll-progress]');
  const storyCards = [...document.querySelectorAll('.story-card')];
  const updateScrollEffects = () => {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    if (progress) progress.style.width = `${max > 0 ? (window.scrollY / max) * 100 : 0}%`;

    storyCards.forEach((card, index) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.innerWidth <= 1040) {
        card.style.transform = '';
        card.style.opacity = '';
        return;
      }
      const rect = card.getBoundingClientRect();
      const distance = Math.max(0, 180 - rect.top);
      const scale = Math.max(0.9, 1 - distance / 2200 - index * 0.004);
      const rotation = Math.min(distance / 950, 1.1);
      card.style.transform = `scale(${scale}) rotate(${rotation}deg)`;
      card.style.opacity = `${Math.max(0.55, 1 - distance / 1300)}`;
    });
  };

  updateScrollEffects();
  window.addEventListener('scroll', updateScrollEffects, { passive: true });
  window.addEventListener('resize', updateScrollEffects);

  fetchCart().catch(() => {});
})();
